import React, { Component } from 'react';

import { HashLink as Link } from 'react-router-hash-link'
import { Form, Tabs, Tab } from 'react-bootstrap';
import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';
import moment from 'moment';

import axios from '../../../services/axios-service';
import * as actions from '../../../store/actions/index';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import CandidateOverview from '../../../components/Client/CandidateOverview/CandidateOverview';
import RecruiterComments from '../../../components/Recruiter/RecruiterComments/RecruiterComments';
import Experience from '../../../components/Recruiter/Experience/Experience';
import Skills from '../../../components/Recruiter/Skills/Skills';
import Languages from '../../../components/Recruiter/Languages/Languages';
import Hobbies from '../../../components/Recruiter/Hobbies/Hobbies';
import Education from '../../../components/Recruiter/Education/Education';
import { checkValidity } from '../../../shared/utility';
import dashboardlogo from '../../../assets/images/dashboard-logo.svg';
import Stepper from '../../../components/UI/Stepper/Stepper';
import CandidatePreview from '../../../components/Recruiter/CandidatePreview/CandidatePreview';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';
import { Accordion, AccordionItem } from '../../../components/UI/Accordion';
import ToastNotification from '../../../components/UI/ToastNotification/ToastNotification';
import Modal from '../../../components/UI/Modal/Modal';
import FileUpload from '../../../hoc/FileUpload/FileUpload';
import Button from '../../../components/UI/Button/Button';
import CandidatePhoto from '../../../components/CandidatePhoto/CandidatePhoto';
import Icon from '../../../components/UI/Icon/Icon';
import config from '../../../config';
import AWS from 'aws-sdk';
import FilePreview from '../../../hoc/FileUpload/FilePreview';


import './ProfileEdit.css';
import { isNull } from 'util';

/**
 * @desc shows the field to add new jobs
 * @param props
 * @return DOMElement
 */
function StepTitle(props) {
  return <h1 className="pool-import-title step-3">{`Candidate list for`} <br/> {props.jobTitle} {props.jobBH}</h1>;
}

class ProfileEdit extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      none: 'none',
      candidateData: {},
      commentsActive:"update",
      experActive:"update",
      skillsActive:"update",
      edtnActive:"update",
      langActive:"update",
      hobbiesActive:"update",
      steps: [{
        title: 'Add Job',
        href: '/pool/import',
        onClick: (e) => {
          e.preventDefault()
        }
      }, {
        title: 'Add Candidates',
        href: '/pool/import',
        onClick: (e) => {
          e.preventDefault()
        }
      },{
        title: 'Review Profiles',
        href: '/pool/import',
        onClick: (e) => {
          e.preventDefault()
        }
      }],
      errorMsg: null,
      errorPosition: null,
      expErrorFieldIndex:[],
      edtnErrorFieldIndex:[],
      hasChanges: false,
      alertVisible: false,
      isPreview: false,
      profileTabKey: "recruiter",
      blurId:null,
      fieldPosition:null,
      completedStatus: (this.props.candidateProfile.candidate_edit_status === "COMPLETED") ? true : false,
      completedStatusText: (this.props.candidateProfile.candidate_edit_status === "COMPLETED") ? "Complete" :"Not Complete",
      completedDisabled: false,
      isShowToast: false,
      toastMessage: null,
      toastVariant: null,
      toastId: null,
      showImageUploadModal:false,
      file:null,
      fileUploadError:null,
      showPreview:false,
      PreviewFile:null,
      uploadStatus:null,
      savingData:false,
      skillName: '',
      isNameEdit:false,
      isEmailEdit:false,
      isFocus:false,
      horizontalLoader: true
    };

    this.handleRecruiterCommentChange = this.handleRecruiterCommentChange.bind(this);
    this.getAlertMsg = this.getAlertMsg.bind(this);
    this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
    this.updateCandidateProfile = this.updateCandidateProfile.bind(this);
    this.autoSaveCandidate = this.autoSaveCandidate.bind(this);
    this.autoSave = null;
    this.handleCandidatePreview = this.handleCandidatePreview.bind(this);
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
    this.handleToggleStatus = this.handleToggleStatus.bind(this);
    this.handleJobTypeChange = this.handleJobTypeChange.bind(this);
    this.handleNoticePeriodChange = this.handleNoticePeriodChange.bind(this);
    this.handleCandidateNameChange = this.handleCandidateNameChange.bind(this);
    this.child = React.createRef();
  }

  /**
  * @desc shows the alert message on autosave
  * @param null
  * @return alert message(pop-up)
  */
  getAlertMsg() {
    if(this.state.alertStyle === "inprogress") {
      return "Auto saving your changes...";
    } else {
      return "Auto saved";
    }
  }
  
  /**
  * @desc closes the alert message of autosave
  * @param null
  * @return null
  */
  handleAlertDismiss() {
    this.setState({ alertVisible: false });
  }
    
  /**
  * @desc changes the candidate name section input field onchange
  * @param event,index
  * @return null
  */
handleCandidateNameChange = (e,id) => {
  e.preventDefault();
  let candidateData = {...this.state.candidateData};
  let candidateName = candidateData.candidate_name!==null?[...candidateData.candidate_name]:'';
  candidateName = e.target.value;
  candidateData.candidate_name = candidateName;
  this.setState({candidateData :candidateData,isNameEdit: true});
  
}

/**
* @desc adds Cnadidate name field on click
* @param event
* @return null
*/
handleCandidateNameEdit = (e) => {   
  this.setState({ isNameEdit: true,isFocus:true });
}

  /**
  * @desc changes the candidate email section input field onchange
  * @param event,index
  * @return null
  */
 handleCandidateEmailChange = (e,id) => {
  e.preventDefault();
  let candidateData = {...this.state.candidateData};
  let candidateEmail = candidateData.candidate_email!==null?[...candidateData.candidate_email]:'';
  candidateEmail = e.target.value;
  candidateData.candidate_email = candidateEmail;
  this.setState({candidateData :candidateData,isEmailEdit: true,errorPosition:''});
  
}

/**
* @desc adds Cnadidate email field on click
* @param event
* @return null
*/
handleCandidateEmailEdit = (e) => {   
  this.setState({ isEmailEdit: true,isFocus:true });
}

 /**
  * @desc changes the NoticePeriod section dropDown onchange
  * @param event,index
  * @return null
  */
  handleNoticePeriodChange = (e) => {  
    e.preventDefault();
    let candidateData={...this.state.candidateData};   
    candidateData.notice_period = e.target.value;
    this.setState({candidateData :candidateData,errorMsg:null,hasChanges: true});
    this.props.onCandidateProfileChange(candidateData.id,candidateData.candidate_name,candidateData.initials,candidateData.candidate_email,candidateData.notice_period,candidateData.job_type);   
  }
    /**
  * @desc changes the jobType section dropDown onchange
  * @param event,index
  * @return null
  */
  handleJobTypeChange = (e) => { 
    e.preventDefault();
    let candidateData={...this.state.candidateData};
    candidateData.job_type = e.target.value;
    this.setState({candidateData :candidateData,errorMsg:null,hasChanges: true});   
    this.props.onCandidateProfileChange(candidateData.id,candidateData.candidate_name,candidateData.initials,candidateData.candidate_email,candidateData.notice_period,candidateData.job_type);   
  }


  /**
  * @desc changes the recruiter comments section input field onchange
  * @param event
  * @return null
  */
  handleRecruiterCommentChange(e){    
    //ConsoleLog('changed', e.target.value);   
    let candidateData={...this.state.candidateData};
    candidateData.recruiter_comments = e.target.value;
    this.setState({candidateData : candidateData, hasChanges: true});    
    if (checkValidity(e.target.value,'required')) {
      this.setState({commentsActive:"activeButton",errorMsg:null });
    }
    else {
      this.setState({commentsActive:"update",errorMsg:"Please provide Recruiter Comments",errorPosition:"RecruiterComments"})
    }    
  }

  /**
  * @desc changes the skills section input field onchange
  * @param event,index
  * @return null
  */
  handleSkillChange = (e) => {

    // e.preventDefault();
    // let candidateData={...this.state.candidateData};
    // let candidateskills = [...candidateData.skills];
    // candidateskills[index].skill = e.target.value;
    // candidateData.skills = candidateskills;
    // this.setState({candidateData,skillsActive:"activeButton",errorMsg:null,hasChanges: true})
    const inputSkill = e.target.value;
    this.setState({
      skillName: inputSkill
    });
  }

  /**
  * @desc adds an additional skill field on click
  * @param event
  * @return null
  */
  // addSkill = (e) => {
  //   ConsoleLog("Amm");
  //   e.preventDefault();
  //   let candidateData = {...this.state.candidateData};
  //   let candidateskills = [...candidateData.skills];
  //   let candidateNewSkillsArray = candidateskills.concat({ id: '0', skill: '' });
  //   candidateData.skills = candidateNewSkillsArray;
	// 	this.setState({ candidateData : candidateData });
    
  // }

  /**
  * @desc changes the language section input field onchange
  * @param event,index
  * @return null
  */
  handleLanguageChange = (e,index) => {
    e.preventDefault();
    let candidateData={...this.state.candidateData};
    let candidatelanguages = [...candidateData.languages];
    candidatelanguages[index][e.target.id] = e.target.value;
    candidateData.languages = candidatelanguages;
    this.setState({candidateData :candidateData,langActive:"activeButton",errorMsg:null});
    if(e.target.id === "skill") {
      this.setState({hasChanges: true});
      this.autoSaveCandidate();
    }
  }

  /**
  * @desc adds an additional language field on click
  * @param event
  * @return null
  */
  addLanguage = (e) => {
    e.preventDefault();    
    let candidateData = {...this.state.candidateData};
    let candidatelanguages = [...candidateData.languages];
    let candidateNewLanguagesArray = candidatelanguages.concat({ id: '0', language: '', skill: 'basic' });
    candidateData.languages = candidateNewLanguagesArray;
		this.setState({ candidateData : candidateData });
    
  }

  /**
  * @desc changes the hobby section input field onchange
  * @param event,index
  * @return null
  */
  handleHobbyChange = (e,index) => {
    e.preventDefault();
    let candidateData={...this.state.candidateData};
    let candidatehobbies = [...candidateData.hobbies];
    candidatehobbies[index] = e.target.value;
    candidateData.hobbies = candidatehobbies;
    this.setState({ candidateData : candidateData,hobbiesActive:"activeButton",errorMsg:null,hasChanges: true});
  }

  /**
  * @desc adds an additional hobby field on click
  * @param event
  * @return null
  */
  addHobby = (e) => {
    e.preventDefault();
    const candidateData={...this.state.candidateData};
    let candidatehobbies = [...candidateData.hobbies];
    candidatehobbies[candidatehobbies.length] = "";
    candidateData.hobbies = candidatehobbies;
		this.setState({ candidateData : candidateData });
    
  }

  /**
  * @desc changes the experience section input field onchange
  * @param event,index
  * @return null
  */
  handleExperienceChange = (e, index) => {
    e.preventDefault();
    let candidateData = {...this.state.candidateData};
    let candidateExperience = [...candidateData.experience];
    candidateExperience[index][e.target.id] = e.target.value;
    candidateData.experience = candidateExperience;

    this.props.onCurrentRoleChange(candidateData.id, candidateExperience[index].title.trim(), candidateExperience[index].company.trim());
    //ConsoleLog('handleexp array',candidateData)
    this.setState({ candidateData : candidateData ,experActive:"activeButton",errorMsg:null,hasChanges: true});
  }

  /**
  * @desc Add a new experience to candidate
  * @param event
  * @return null
  */
  addExperience = (e) => {
    e.preventDefault();
    let candidateData = {...this.state.candidateData};
    let candidateExperience = [...candidateData.experience];
    let candidateNewExperienceArray = candidateExperience.concat({ id: '0', dateStart: '',dateEnd:'',title:'',company:'',description:'',current_role:0 });
    candidateData.experience = candidateNewExperienceArray;
    this.setState({ candidateData});
  }

  /**
  * @desc Remove an experience from candidate
  * @param (event, index)
  * @return null
  */
  removeExperience = (e, index) => {
    //ConsoleLog("removeExperience")
    e.preventDefault();
    let candidateData = this.state.candidateData;
    let candidateExperience = candidateData.experience;
    candidateExperience.splice(index, 1);
    candidateData.experience = candidateExperience;
    this.setState({ 
      candidateData, 
      experActive:"activeButton", 
      errorMsg:null, 
      hasChanges: true,
      isShowToast:true,
      toastMessage: "Removed successfully",
      toastVariant: "success",
      toastId: "tid" + (new Date()).getTime() 
    });
    const DontshowAutoSave=true;
    this.autoSaveCandidate(DontshowAutoSave);
  }

  /**
  * @desc changes the date in  experience section 
  * @param name, index , year , month
  * @return null
  */
  handleExperienceDateChange = (e,name, index, year, month) => {
    e.preventDefault();
    let candidateData = {...this.state.candidateData};
    let candidateExperience = [...candidateData.experience];
    candidateExperience[index][name] = moment(new Date(year, month)).format('YYYY-MM-DD HH:mm:ss');
    candidateData.experience = candidateExperience;
    if(candidateExperience[index].dateEnd > candidateExperience[index].dateStart || (name === "dateStart" && (candidateExperience[index].dateEnd === null || candidateExperience[index].dateEnd === "0000-00-00 00:00:00" || candidateExperience[index].dateEnd === "" ))){
      this.setState({ candidateData : candidateData,experActive:"activeButton",errorMsg:null,hasChanges: true});
      this.autoSaveCandidate();
    } else {
      this.setState({ candidateData:candidateData, blurId:name, fieldPosition:index });
    }
  }
  
  /**
  * @desc changes the current role in experience section 
  * @param isChecked(boolean),index,event
  * @return null
  */
  handleCurrentRole = (isChecked, index, e) => {
    //e.preventDefault();
    const candidateData = {...this.state.candidateData};
    let candidateExperience = [...candidateData.experience];
    if(candidateExperience.length > 1) {
      candidateExperience.map((exp) => exp.current_role = '0');
    }

    candidateExperience[index].current_role = !e.target.checked ? '0' : '1';
    candidateData.experience = candidateExperience;
    if(candidateExperience[index].current_role === '1') {
      candidateData.current_employer = candidateExperience[index].company;
      candidateData.current_job_title = candidateExperience[index].title;
      candidateData.experience[index].dateEnd = '';
    } else {      
      if(candidateExperience.filter((currentExp) => (currentExp.current_role === "1" && currentExp.title !== "" && currentExp.company !== "")).length > 0) {
        const currentRole = candidateExperience.filter((currentExp) => (currentExp.current_role === "1" && currentExp.title !== "" && currentExp.company !== ""));
        candidateData.current_employer = currentRole[0].company;
        candidateData.current_job_title = currentRole[0].title;
      } else {
        candidateData.current_employer = "";
        candidateData.current_job_title = "";
      }    
    }    
    this.setState({ candidateData: candidateData,experActive:"activeButton",errorMsg:null,hasChanges: true},function(){
      this.autoSaveCandidate();
      this.props.onCurrentRoleChange(candidateData.id, candidateData.current_job_title, candidateData.current_employer);
      // this.props.onGetTalentPoolRecruiter(this.props.jobId);
    });
  };

  /**
  * @desc changes the education section on input change 
  * @param isChecked(boolean),index,event
  * @return null
  */
  handleEducationChange = (e, index) => {
    e.preventDefault();
    let candidateData = {...this.state.candidateData};
    let candidateEducation = [...candidateData.education];
    candidateEducation[index][e.target.id] = e.target.value;
    candidateData.education = candidateEducation;
    this.setState({ candidateData : candidateData ,edtnActive:"activeButton",errorMsg:null,hasChanges: true});
  }

  /**
  * @desc Add an experience for candidate
  * @param (event)
  * @return null
  */
  addEducation = (e) => {
    e.preventDefault();
    let candidateData = {...this.state.candidateData};
    let candidateEducation = [...candidateData.education];
    let candidateNewEducationceArray = candidateEducation.concat({ id: '0', dateStart: '',dateEnd:'',accreditation:'',institution:'',location:'',description:'',award:'',isTraining:0 });
    candidateData.education = candidateNewEducationceArray;
    this.setState({ candidateData});
  }

  /**
  * @desc Remove an experience from candidate
  * @param (event, index)
  * @return null
  */
  removeEducation = (e, index) => {
    e.preventDefault();
    let candidateData = this.state.candidateData;
    let candidateEducation = candidateData.education;
    candidateEducation.splice(index, 1);
    candidateData.education = candidateEducation;
    this.setState({ 
      candidateData, 
      edtnActive:"activeButton", 
      errorMsg:null, 
      hasChanges: true,
      isShowToast:true,
      toastMessage: "Removed successfully",
      toastVariant: "success",
      toastId: "tid" + (new Date()).getTime() 
     });
     const DontshowAutoSave=true;
     this.autoSaveCandidate(DontshowAutoSave);
  }

  /**
  * @desc changes the date in  eductaion section 
  * @param name ,index , year , month
  * @return null
  */
  handleEducationDateChange = (e,name, index, year, month) => {
    e.preventDefault();
    let candidateData = {...this.state.candidateData};
    let candidateEducation = [...candidateData.education];
    candidateEducation[index][name] = moment(new Date(year, month)).format('YYYY-MM-DD HH:mm:ss');
    candidateData.education = candidateEducation;
   
    if(candidateEducation[index].dateEnd > candidateEducation[index].dateStart || 
      (name === "dateStart" && (candidateEducation[index].dateEnd === null || candidateEducation[index].dateEnd === "0000-00-00 00:00:00" || candidateEducation[index].dateEnd === "" ))){
      this.setState({ candidateData : candidateData,edtnActive:"activeButton",errorMsg:null,hasChanges: true});
      this.autoSaveCandidate();
    } else {
      this.setState({ candidateData:candidateData, blurId:name, fieldPosition:index });
    }
  }

  /**
  * @desc toggles between traning and education
  * @param event,index
  * @return null
  */
  handleIsTraining = (e, index) => {
    const candidateData = {...this.state.candidateData};
    let candidateEducation = [...candidateData.education];

    candidateEducation[index].isTraining = e.target.value;
    candidateData.education = candidateEducation;
        
    this.setState({ candidateData: candidateData,edtnActive:"activeButton",errorMsg:null,hasChanges: true});
    this.autoSaveCandidate();
  };

  handleOnBlur = (evt,msg,pos) => {
    if(evt.target.value.trim() === "" || evt.target.value.trim() === null) {      
      this.setState({ errorMsg:msg,errorPosition:pos,hasChanges: false });
    } else {
      this.autoSaveCandidate();
      this.setState({ errorMsg:null,hasChanges: true });
    }
  }

  handleSkillOnBlur = (evt) => {

    let candidateData = {...this.state.candidateData};
    let candidateskills = [...candidateData.skills];

    if(evt.target.value !== null && evt.target.value !==''){
      const randomId = Math.floor(Math.random() * 11);
      let candidateNewSkillsArray = candidateskills.concat({ id: randomId+evt.target.value, skill: evt.target.value });
      candidateData.skills = candidateNewSkillsArray;
      this.setState(
        { candidateData : candidateData,skillsActive: "activeButton"},
        () => this.autoSaveCandidate()
      );
      this.setState({ errorMsg:null,hasChanges: true,errorPosition:null,hasChanges: true  });
    }
    
  }

  handleSkillOnEnter = (evt) => {
    if (evt.key === 'Enter') {
      
      let candidateData = {...this.state.candidateData};
      let candidateskills = [...candidateData.skills];

      if(evt.target.value !== null && evt.target.value !==''){
        const randomId = Math.floor(Math.random() * 11);
        let candidateNewSkillsArray = candidateskills.concat({ id: randomId+evt.target.value, skill: evt.target.value });
        candidateData.skills = candidateNewSkillsArray;
        this.setState(
          { candidateData : candidateData,skillsActive: "activeButton"},
          () => this.autoSaveCandidate()
        );
        //this.autoSaveCandidate();
        this.setState({ errorMsg:null,hasChanges: true,errorPosition:null });
      }
    }
  }

  handleSkillRemove = (skill) => {

    let candidateData = {...this.state.candidateData};
    let candidateskills = [...candidateData.skills];

    if(skill){
      let candidateNewSkillsArray = candidateskills.filter(item => item.id !== skill);
      candidateData.skills = candidateNewSkillsArray;
      this.setState(
        { candidateData : candidateData,skillsActive: "activeButton"},
        () => this.autoSaveCandidate()
      );
      this.setState({ errorMsg:null,hasChanges: true,errorPosition:null });
    }
    
  }

  handleHobbiesOnBlur = (evt) => {
    // if(this.state.candidateData.hobbies.filter(hobby => (hobby && hobby.trim() != '')).length === 0) {      
    //   this.setState({
    //     errorMsg: "Please provide at least one interest to continue",
    //     errorPosition: "hobby"
    //   });
    // } else {
    //   this.autoSaveCandidate();
    //   this.setState({ errorMsg:null,hasChanges: true,errorPosition:null });
    // }

    this.autoSaveCandidate();
    this.setState({ errorMsg:null,hasChanges: true,errorPosition:null,hasChanges: true  });
  }


  handleOnBlurExperience = (evt, index) => {
    if(evt.target.value.trim() === "" || evt.target.value.trim() === null) {  
      this.setState({ blurId :evt.target.id,fieldPosition : index});
    } else {
      this.autoSaveCandidate();
      this.setState({ errorMsg:null});
    }
  }

  handleOnBlurEducation = (evt, index) => {
    if(evt.target.value.trim() === "" || evt.target.value.trim() === null) {        
      this.setState({ blurId :evt.target.id,fieldPosition : index});
    } else {
      this.autoSaveCandidate();
      this.setState({ errorMsg:null});
    }
  }

  handleLanguagesOnBlur = (evt) => {   
    this.autoSaveCandidate();
    this.setState({ errorMsg:null,hasChanges: true,errorPosition:null,hasChanges: true  });
    // The bellow code is commented during TK integration to remove the mandatory language check
    // if(this.state.candidateData.languages.filter(langObj => (langObj.language && langObj.language.trim() != '')).length === 0) {      
    //   this.setState({
    //     errorMsg: "Please provide at least one language to continue",
    //     errorPosition: "language"
    //   });
    // } else {
    //   this.autoSaveCandidate();
    //   this.setState({ errorMsg:null,hasChanges: true,errorPosition:null });
    // }
  }
  handleCandidateNameOnBlur = (evt) => {
    this.setState({isNameEdit:false,isFocus:false});
    let candidateData={...this.state.candidateData};
    //ConsoleLog('name', candidateData.candidate_name);
    const CandidateName= candidateData.candidate_name.replace(/^(\s*)|(\s*)$/g, '').replace(/\s+/g, ' ')
    const nameArr = CandidateName.split(" ");
    const candidateFname = nameArr.splice(0,1).join();
    const candidateLname = nameArr.join(" ");
    const candidateIntials = candidateFname.charAt(0)+candidateLname.charAt(0);
    candidateData.candidate_name = CandidateName;
    candidateData.initials = candidateIntials.toUpperCase();
    const candidateEmail = candidateData.candidate_email;
    let errorPositionEmail='';
    // if(evt.target.value.trim() !== "" || evt.target.value.trim() !== null) {  
      if(candidateEmail&&candidateEmail.trim() !=="" && candidateEmail.trim() !==null && !checkValidity(candidateEmail,'isEmail')) {
       
        errorPositionEmail = 'Email'
        this.setState({errorPosition:errorPositionEmail});
      }else{
      this.autoSaveCandidate();
         this.setState({isNameEdit:false,isFocus:false,candidateData});
      this.props.onCandidateProfileChange(this.props.candidateProfile.id,candidateData.candidate_name,candidateIntials.toUpperCase(),candidateData.candidate_email,candidateData.notice_period,candidateData.job_type);
    // }
      }
  }
  handleCandidateEmailOnBlur = (evt) => {
    this.setState({isEmailEdit:false,isFocus:false});
    let candidateData={...this.state.candidateData};  
    const candidateEmail = candidateData.candidate_email;
    
    let errorPositionEmail=this.state.errorPosition;
    if(candidateEmail.trim() !=="" && candidateEmail.trim() !==null && !checkValidity(candidateEmail,'isEmail')) {
      errorPositionEmail = 'Email'
      this.setState({errorPosition:errorPositionEmail});
    }
    else{
      candidateData.candidate_email=candidateEmail; 
      this.autoSaveCandidate();
    this.setState({isEmailEdit:false,isFocus:false,candidateData});
    this.props.onCandidateProfileChange(this.props.candidateProfile.id,candidateData.candidate_name,candidateData.initials.toUpperCase(),candidateData.candidate_email,candidateData.notice_period,candidateData.job_type);

    }
    
  }
  

  /**
  * @desc updates the filed changes in candidate profile edit page
  * @param event,section in edit page
  * @return null
  */
  handleUpdateProfile = (e,section) => {
    e.preventDefault();
    let candidateDetails = {...this.state.candidateData};

    candidateDetails.updateProfile = 1;
    const hobbiesArray = [...candidateDetails.hobbies];
    const langArray = [...this.state.candidateData.languages];
    const skillArray = [...this.state.candidateData.skills];

    candidateDetails.recruiter_comments = (candidateDetails.recruiter_comments && candidateDetails.recruiter_comments !==null) ? candidateDetails.recruiter_comments.trim() : "";  
    candidateDetails.workArray = [...this.state.candidateData.experience];    
    candidateDetails.eduArray = [...this.state.candidateData.education];

    const newSkillArray = skillArray.filter( skillObj => (skillObj.skill && skillObj.skill.trim() != ''));
    candidateDetails.skillArray = newSkillArray;

    const newlangArray = langArray.filter( lang => (lang.language && lang.language.trim() != ''));
    candidateDetails.langArray = newlangArray;

    const newHobbies = hobbiesArray.filter( hobby => hobby.trim() != '');
    candidateDetails.hobbies = newHobbies;
    candidateDetails.saveType = "MANUAL";
    candidateDetails.userId = this.props.userDetail.user_id ;
    candidateDetails.userName = this.props.userDetail.user_fname +" "+ this.props.userDetail.user_lname;

    this.updateCandidateProfile(candidateDetails,section);
  }

  /**
  * @desc validates the user input and updates to the backend
  * @param candidateDetails,section in edit page
  * @return null
  */
  updateCandidateProfile = (candidateDetails,section) => {   
    if(section === "skillsActive" && this.state.candidateData.skills.filter(skillObj => (skillObj.skill && skillObj.skill.trim() != '')).length === 0) {
      this.setState({
        errorMsg: "Please provide at least one skill to continue",
        errorPosition: "skills"
      });
    }
    // else if(section === "hobbiesActive" && this.state.candidateData.hobbies.filter(hobby => (hobby && hobby.trim() != '')).length === 0) {
    //   this.setState({
    //     errorMsg: "Please provide at least one hobby to continue",
    //     errorPosition: "hobby"
    //   });
    // }
    // else if(section === "langActive" && this.state.candidateData.languages.filter(langObj => (langObj.language && langObj.language.trim() != '')).length === 0) {
    //   this.setState({
    //     errorMsg: "Please provide at least one language to continue",
    //     errorPosition: "language"
    //   });
    // }
    else if(section === "experActive" && this.state.candidateData.experience.filter((exp) => (exp.title.trim() === "" || 
    exp.company.trim() === "" || (exp.dateStart > exp.dateEnd && moment(new Date(exp.dateEnd))._isValid && exp.current_role === '0') || exp.description.trim() ==="") || !moment(new Date(exp.dateStart))._isValid  || (!moment(new Date(exp.dateEnd))._isValid) && exp.current_role === '0').length > 0) {
      let expErrorFieldIndex = [];
      
      this.state.candidateData.experience.map((exp, index) => {
        if(exp.title.trim() === "" || exp.company.trim() === "" || (exp.dateStart > exp.dateEnd && moment(new Date(exp.dateEnd))._isValid && exp.current_role === '0') 
        || exp.description.trim() ==="" || !moment(new Date(exp.dateStart))._isValid || (!moment(new Date(exp.dateEnd))._isValid) && exp.current_role === '0') {
          expErrorFieldIndex = expErrorFieldIndex.concat(index);        }
      }); 
      this.setState({
        expErrorFieldIndex: expErrorFieldIndex
      });
    }
    else if(section === "edtnActive" && this.state.candidateData.education.filter((edtn) => (edtn.accreditation.trim() === "" || edtn.award.trim() === "" || edtn.dateStart > edtn.dateEnd || edtn.award.trim() === "" || edtn.institution.trim() === "" ||  edtn.description.trim() ==="" || !moment(new Date(edtn.dateStart))._isValid) || !moment(new Date(edtn.dateEnd))._isValid).length > 0) {
      let edtnErrorFieldIndex = [];
      this.state.candidateData.education.map((edtn, index) => {
        if(edtn.accreditation.trim() === "" || edtn.award.trim() === ""|| edtn.dateStart > edtn.dateEnd || edtn.award.trim() === "" || edtn.institution.trim() === "" || edtn.description.trim() ==="" || !moment(new Date(edtn.dateStart)._isValid) || !moment(new Date(edtn.dateEnd)._isValid)) {
          edtnErrorFieldIndex = edtnErrorFieldIndex.concat(index);        }
      });
      this.setState({
        edtnErrorFieldIndex: edtnErrorFieldIndex
      });
    }
    else  {
      axios.post("/galaxy/job/" + this.props.jobId + "/candidate/" + candidateDetails.id, JSON.stringify(candidateDetails))
      .then((response) => { 
        if(this.state.candidateData.candidate_edit_status !== "STARTED" && this.state.candidateData.candidate_edit_status !== "COMPLETED") {
          const candidateData = {...this.state.candidateData};
          // ConsoleLog("updatecandidate",candidateData)
          candidateData.candidate_edit_status = "STARTED";
          this.setState({ candidateData:candidateData });
          this.props.onUpdateCandidateEditStatus(candidateDetails.id, 'STARTED');
        }
        this.setState({[section] : "updated" });
      })
      .catch((error) => {
        ConsoleLog(error);
        throw error;
      });
    }
    
  }
  /**
   * @desc cloase toast notification
   * @param null
   * @return null
   */
  handleCloseToastNotification =()=>{
    this.setState({
      isShowToast: false,
      toastMessage: null,
      toastVariant: null,
      toastAutoClose: false
    })
  }


  /**
  * @desc autosave the changes on user input
  * @param candidateDetails,section in edit page
  * @return null
  */
  autoSaveCandidate = (DontshowAutoSave) => {
    //ConsoleLog("noticeperiod autosaave ",this.state.candidateData.notice_period)
    // !DontshowAutoSave?
    //   (this.setState({  alertStyle: 'inprogress', 
    //                    alertVisible: true,
    //                    isShowToast: true,
    //                    toastMessage: 'Auto saving your changes',
    //                    toastVariant: 'info',
    //                    toastId: "tid" + (new Date()).getTime() 
    //                   }))
    //   :"";
      let candidateDetails = {...this.state.candidateData};
      const hobbiesArray = [...candidateDetails.hobbies];
      const langArray = [...this.state.candidateData.languages];
      const skillArray = [...this.state.candidateData.skills];


      candidateDetails.updateProfile = 1;
      candidateDetails.recruiter_comments = (this.state.candidateData.recruiter_comments && this.state.candidateData.recruiter_comments !==null) ? this.state.candidateData.recruiter_comments.trim() : ""; 
      candidateDetails.workArray = [...this.state.candidateData.experience];      
      candidateDetails.eduArray = [...this.state.candidateData.education];
      
      const newSkillArray = skillArray.filter( skillObj => (skillObj.skill && skillObj.skill.trim() != ''));
      candidateDetails.skillArray = newSkillArray;

      const newlangArray = langArray.filter( lang => (lang.language && lang.language.trim() != ''));
      candidateDetails.langArray = newlangArray;

      const newHobbies = hobbiesArray.filter( hobby => hobby.trim() != '');
      candidateDetails.hobbies = newHobbies;

      candidateDetails.saveType = "AUTO";
      candidateDetails.userId = this.props.userDetail.user_id ;
      candidateDetails.userName = this.props.userDetail.user_fname +" "+ this.props.userDetail.user_lname;
      // candidateDetails.notice_period = this.state.candidateData.notice_period;
      // candidateDetails.job_type = this.state.candidateData.job_type;
     let CandidateName= candidateDetails.candidate_name.replace(/^(\s*)|(\s*)$/g, '').replace(/\s+/g, ' ');
      const nameArr = CandidateName.split(" ");
      const candidateFname = nameArr.splice(0,1).join();
      const candidateLname = nameArr.join(" ");
      const candidateIntials = candidateFname.charAt(0)+candidateLname.charAt(0);
      candidateDetails.candidate_name = CandidateName;//.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');;
      candidateDetails.initials = candidateIntials.toUpperCase();

      this.setState({ hasChanges: false});
       this.props.onCandidateProfileDataChange(candidateDetails);
      // ConsoleLog("candidateDetails",candidateDetails)
      axios.post("/galaxy/job/" + this.props.jobId + "/candidate/" + candidateDetails.id, JSON.stringify(candidateDetails))
        .then((response) => {  
          if(this.state.candidateData.candidate_edit_status !== "STARTED" && this.state.candidateData.candidate_edit_status !== "COMPLETED") {
            //ConsoleLog('cand status ', this.state.candidateData.candidate_edit_status);
            const candidateData = {...this.state.candidateData};
            // ConsoleLog("autoupdatecandidate",candidateData)
            candidateData.candidate_edit_status = "STARTED";
            this.setState({ candidateData:candidateData });            
            this.props.onUpdateCandidateEditStatus(candidateDetails.id, 'STARTED');
          }
          
          !DontshowAutoSave?(
            (!this.state.isShowToast || this.state.toastMessage !== "Removed successfully") ? 
              this.setState({ alertVisible: true,
                alertStyle: 'success',
                 isShowToast: true,
                 toastMessage: 'Auto saved',
                 toastVariant: 'success',
                 toastAutoClose: false ,
                 toastId: "tid" + (new Date()).getTime() 
               })
            : null ):"";
        })
        .catch((error) => {
          ConsoleLog(error);
          throw error;
          this.setState({ 
             isShowToast: true,
             toastMessage: 'Network error',
             toastVariant: 'error',
             toastAutoClose: false ,
             toastId: "tid" + (new Date()).getTime() 
           });
          });
  }

  /**
  * @desc shows the preview as client view on click
  * @param event
  * @return null
  */
  handleCandidatePreview = (e) => {
    e.preventDefault();
    const isPreview = (!this.state.isPreview);
    this.setState({ isPreview : isPreview});
    if(this.state.isShowToast) {
      this.handleCloseToastNotification();
    }
  }

  /**
  * @desc changes the tab onclick
  * @param candidateDetails,section in edit page
  * @return null
  */
  handleProfileTabSelect = (key) => {
    this.setState({ profileTabKey: key });
  }

  /**
  * @desc component did mount of the component
  * @param null
  * @return null
  */
  componentDidMount() {
    if(this.props.continueClicked){
      this.setState({ horizontalLoader: true});

      setTimeout(() => {
        this.setState({horizontalLoader: false});
      }, 1500)
    
    }
    this.setState({ candidateData : this.props.candidateProfile });
  }

  /**
  * @desc componentDidUpdate of component
  * @param event,index
  * @return null
  */
  componentDidUpdate(prevProps, prevState) { 
    if((this.props.candidateProfile !== prevProps.candidateProfile) || (Object.keys(this.state.candidateData).length === 0 && Object.keys(this.props.candidateProfile).length > 0 )) {
      const {education, experience} = {...this.props.candidateProfile};
      // experience.map(exp => {
      //   exp.description = exp.description.replace(/(^|\n)\s*\*\s+/g, '$1* ');
      // });
      // education.map(edu => {
      //   edu.description = edu.description.replace(/(^|\n)\s*\*\s+/g, '$1* ');
      // });
      
      if(this.props.candidateProfile.id !== prevProps.candidateProfile.id){
        this.props.handleViewClick();
        this.setState({horizontalLoader: true, isShowToast: false })

        setTimeout(() => {
          this.setState({horizontalLoader: false});
        }, 1000)

      }else{
        this.props.handleViewClick();
      }
      this.setState({ candidateData : this.props.candidateProfile,
                      commentsActive:"update",
                      experActive:"update",
                      skillsActive:"update",
                      edtnActive:"update",
                      langActive:"update",
                      hobbiesActive:"update",
                      errorMsg:null,
                      errorPosition: null,
                      expErrorFieldIndex:[],
                      edtnErrorFieldIndex:[],
                      blurId:null,
                      fieldPosition:null,
                      completedStatus: (this.props.candidateProfile.candidate_edit_status === "COMPLETED") ? true : false,
                      completedStatusText: (this.props.candidateProfile.candidate_edit_status === "COMPLETED") ? "Complete" :"Not Complete"                
      });

      
    }
    
    if(this.state.candidateData.hobbies && this.state.candidateData.hobbies.filter(hobby => (hobby && hobby.trim() != '')).length === 0 && this.state.profileTabKey=="hobbies") {
      this.setState({profileTabKey: "recruiter"});
    }

    if(this.state.candidateData.languages && this.state.candidateData.languages.filter(lang => (lang.language != '')).length === 0 && this.state.profileTabKey=="languages") {
      this.setState({profileTabKey: "recruiter"});
    }

    if((prevState.candidateData.notice_period !== this.state.candidateData.notice_period ||prevState.candidateData.job_type !== this.state.candidateData.job_type) && this.state.hasChanges) {
      this.autoSaveCandidate();
    }

    if(prevState.candidateData.skills !== this.state.candidateData.skills){
      this.setState({skillName:''});
    }
  }



  /**
  * @desc component will unmount of the component
  * @param null
  * @return null
  */
  componentWillUnmount(){
    clearInterval(this.autoSave);
  }

  handleToggleStatus = () => {
    this.setState({ completedDisabled: true });
    const completedStatus = (this.state.completedStatus) ? false : true;
    const completedStatusText = (completedStatus) ? 'Complete' : 'Not Complete';
    const editStatus = (completedStatus) ? "COMPLETED"  : "STARTED";

    const postDetails = {
      candidateId: this.state.candidateData.id,
      jobId: (this.props.jobId) ? this.props.jobId : this.props.match.params.jobId,
      editStatus: editStatus,
      userId:this.props.userDetail.user_id,
      userName:this.props.userDetail.user_fname + " " + this.props.userDetail.user_lname
      
    }
    //  this.props.onCandidateProfileDataChange(this.state.candidateData);
    this.props.onUpdateCandidateEditStatus(this.state.candidateData.id, editStatus);
    axios.post("/galaxy/job/" + this.props.jobId + "/candidate/" + this.state.candidateData.id, JSON.stringify(postDetails))
      .then((response) => {  
        this.setState({ completedDisabled: false });
        if(response.data.message === "success" && !this.state.isNameEdit&& !this.state.isEmailEdit) {
          const candidateData = {...this.state.candidateData};
         
          candidateData.candidate_edit_status = editStatus;          
          this.setState({ candidateData:candidateData, completedStatus: completedStatus, completedStatusText: completedStatusText });
        }
      })
      .catch((error) => {
        this.setState({ completedDisabled: false });
        ConsoleLog(error);
        throw error;
      });    
  }

  imageUpdateModal = () => {
    this.setState({ showImageUploadModal: true});
  }

  closeShowImageUploadModal = ()=> {
    this.setState({ 
      showImageUploadModal: false, 
      file:null,
      fileUploadError:null,
      showPreview:false,
      PreviewFile:null,
      uploadStatus:null 
    });
  }

  addFile = (file, fileUploadError) => {  
    this.setState({ file: file, fileUploadError: fileUploadError,uploadStatus:"upload" });
  }

  removeCandidateImage = (index,filePath) => { 
    this.setState({uploadStatus:"remove",file:null});
    this.child.current.removeFile();
  }    


  onDrop = (file) => {   
    if(this.state.uploadStatus === "upload") {
      this.setState({uploadStatus:null});
      this.uploadFile(file, 'profilePhoto/candidates/' +  this.props.candidateProfile.id + '/' + file.name)
          .then((data)=> {
            const candidateData = {
              candidateId:this.props.candidateProfile.id,
              jobId:this.props.jobId,
              candidateImage: data.Key,
              userId : this.props.userDetail.user_id ,
              userName : this.props.userDetail.user_fname +" "+ this.props.userDetail.user_lname
            }
            //ConsoleLog("key",data);
              
            axios.post("/galaxy/job/" + this.props.jobId + "/candidate/" + this.props.candidateProfile.id,JSON.stringify(candidateData))
              .then(
              (response) => {
                if(response.data.message === "success") {
                  const candidateDetails = {...this.state.candidateData};
                  if(candidateDetails.candidate_edit_status === "NOT STARTED") {
                    this.props.onUpdateCandidateEditStatus(candidateDetails.id, 'STARTED');
                  }
                  this.props.onUpdateCandidateProfileImage(candidateData.candidateImage, this.props.candidateProfile.id,this.props.user);
                }
                this.setState({ showImageUploadModal: false,
                  isShowToast: true,
                  toastMessage: 'Profile image uploaded successfully!',
                  toastVariant: 'success', 
                  toastId: "tid" + (new Date()).getTime(),
                  uploadStatus:null,
                  file:null,
                  fileUploadError:null,
                  showPreview:false,
                  PreviewFile:null,
                  savingData:false,
                });
                  
              })
              .catch((err) => { this.setState({ showImageUploadModal: false}); 
              ConsoleLog("error",err);
            }); 
          },
          (err) => { 
            this.setState({ showImageUploadModal: false});
          });
      }
     else if(this.state.uploadStatus === "remove" && this.props.candidateProfile.s3SignedUrl) {
      this.setState({uploadStatus:null,savingData:true});
      this.removeFile(this.props.candidateProfile.candidate_image)
      .then((data)=> {
      const candidateData = {
       candidateId:this.props.candidateProfile.id,
       jobId:this.props.jobId,
       candidateImage: null,
       userId : this.props.userDetail.user_id ,
       userName : this.props.userDetail.user_fname +" "+ this.props.userDetail.user_lname
      }
      axios.post("/galaxy/job/" + this.props.jobId + "/candidate/" + this.props.candidateProfile.id,JSON.stringify(candidateData))
      .then(
      (response) => {
        if(response.data.message === "success") {
          this.props.onUpdateCandidateProfileImage(candidateData.candidateImage, this.props.candidateProfile.id,this.props.user);
          this.setState({ 
          isShowToast: true,
          toastMessage: 'Profile image removed succesfully!',
          toastVariant: 'success', 
          toastId: "tid" + (new Date()).getTime(),
          showImageUploadModal:false,
          uploadStatus:null,
          file:null,
          fileUploadError:null,
          showPreview:false,
          PreviewFile:null,
          savingData:false,
         });
        }
          
      })
      .catch((err) => { this.setState({ showImageUploadModal: false}); 
      ConsoleLog("error",err);
      }); 
      },
      (err) => { 
        this.setState({ showImageUploadModal: false});
      });

    }
    
  }

  // previews = (file) => {
  //   if(file.length>0) {
  //     this.setState({showPreview:true,PreviewFile:file});
  //   }

  // }

  uploadFile = (file, filePath) => {
    //ConsoleLog("attr",this.props.attributes)
    AWS.config.update({
      region : config.cognito.region
    });
    
    let logins = {}
    logins['cognito-idp.'+ config.cognito.region +'.amazonaws.com/' + config.cognito.userPool] = this.props.user.storage['CognitoIdentityServiceProvider.'+ config.cognito.clientId +'.' + this.props.attributes.email + '.idToken'];
    // Add the User's Id Token to the Cognito credentials login map.
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: config.cognito.identityPool,
        Logins: logins
    });
          
    let S3 = new AWS.S3({ params: { Bucket: config.cognito.bucketName }});
    // Specify the S3 upload parameters
    let params = {
      Key: filePath,
      ContentType: file.type,
      Body: file,
      // ACL: 'public-read'
    };

    return new Promise(function(resolve, reject) {
      S3.upload(params, function(err, data) {
          if (err) {
              reject(err);
          } else {              
             resolve(data);
          }
      });
    });
  }
  removeFile= (filePath) => {
    //ConsoleLog("file",filePath);
    AWS.config.update({
      region : config.cognito.region
    });
    
    let logins = {}
    logins['cognito-idp.'+ config.cognito.region +'.amazonaws.com/' + config.cognito.userPool] = this.props.user.storage['CognitoIdentityServiceProvider.'+ config.cognito.clientId +'.' + this.props.attributes.email + '.idToken'];
    // Add the User's Id Token to the Cognito credentials login map.
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: config.cognito.identityPool,
        Logins: logins
    });
          
    let S3 = new AWS.S3({ params: { Bucket: config.cognito.bucketName }});
    // Specify the S3 upload parameters
    let params = {
      Key: filePath
      // ACL: 'public-read'
    };

    return new Promise(function(resolve, reject) {
      S3.deleteObject(params, function(err, data) {
          if (err) {
              reject(err);
          } else {              
            resolve(data);
          }
      });
    });
  }

  render() {
    
    const candidate_id = this.props.activeCandidateId;
    const candidate = {...this.state.candidateData};

    return (      
      (this.state.isPreview) ? 
        (!this.props.viewClicked && !this.state.horizontalLoader) ?
        <CandidatePreview 
          candidate={candidate} 
          candidate_id={candidate_id} 
          jobTitleId={(this.props.jobId) ? this.props.jobId : this.props.match.params.jobId} 
          handleCandidatePreview={this.handleCandidatePreview} 
          handleProfileTabSelect={this.handleProfileTabSelect.bind(this)}
          profileTabKey={this.state.profileTabKey}
        /> : 
        <div className="rec-profile-edit-loader">
            <div className="profile-tabs">
              <ul role="tablist" class="nav nav-tabs">
                <li role="presentation" class="active">
                  <a href="#"></a>
                </li>
              </ul>
            </div>
            <div className="timeline-wrapper">
              <div class="candidate-overview">
                <div class="profile-picture-container">
                  <div class="profile-picture">
                    <div class="Candidate-Photo-Container">
                      <div className="background-mask face-mask"></div>
                    </div>
                  </div>
                </div>
                <div class="details">
                  <h1 class="candidate-name"><div className="background-mask line-mask"></div></h1>
                  <div class="highlight-experience row">
                    <div class="col-md-6 col-xs-12"><div className="background-mask line-mask"></div></div>
                    <div class="col-md-6 col-xs-12"><div className="background-mask line-mask"></div></div>
                  </div>
                  <div class="email-wrapper">
                  </div>
                  <div>
                    <div class="line"></div>
                    <div class="prev-experience-container">
                      <h2 class="cs"><div className="background-mask line-mask"></div></h2>
                      <div class="show-grid previous-experience-content row">
                        <div class="col-md-12">
                          <div className="background-mask line-mask"></div>
                        </div>
                      </div>
                    </div>
                    <div class="lineb notice-period-line"></div>
                    <div class="row">
                      <div class="col-md-6 col-xs-12"><span class="notice"><div className="background-mask line-mask"></div></span></div>
                      <div class="col-md-6 col-xs-12"><span class="jobtype"><div className="background-mask line-mask"></div></span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      :
      <div>
        <div className="dashboard-nav-header-mobile">
          {/* Mobile View Section starts */}	
          <MediaQuery query="(max-device-width: 767px)">
            <Link className="dashboardlogo" to="/recruiter/dashboard">
              <img className="img-responsive dashboard-nav-logo-mobile" src={dashboardlogo} alt="logo"/>
            </Link>
            <StepTitle
              jobTitle={(this.props.location && this.props.location.state.jobTitle) ? this.props.location.state.jobTitle : "" }
              jobBH={(this.props.location && this.props.location.state.jobBH) ? this.props.location.state.jobBH : ""} />
          </MediaQuery> 
          {/* Mobile View Section Ends */}
        </div>
        {/* Mobile View Section starts */}	
        <MediaQuery query="(max-device-width: 767px)">
          <div className="stepper-cont">
            <div className="stepper">
              <Stepper steps={ this.state.steps } activeStep={ 2 }/>
            </div>
          </div>
        </MediaQuery>
        {/* Mobile View Section Ends */}
        <div className="cand-profile-edit">
          {/* {Object.keys(candidate).length > 0  ? */}
          { candidate.id && !this.props.viewClicked &&!this.state.horizontalLoader?
          <div className="profile-edit">
            <Tabs defaultActiveKey={1} id="uncontrolled-tab-example" className="profile-tabs" animation={false}>
              <Tab eventKey={1} title="Profile">
                <div className="profile-edit__candidate-overview profile">
                  <CandidateOverview 
                    candidate={candidate} 
                    candidate_id={candidate_id} 
                    print={false} 
                    open={false} 
                    isProfileEdit={true} 
                    handleCandidatePreview={this.handleCandidatePreview} 
                    isPreview={false}    
                    isNameEdit={this.state.isNameEdit} 
                    isEmailEdit={this.state.isEmailEdit}  
                    isFocus={this.state.isFocus}              
                    isChecked={this.state.completedStatus}
                    handleToggleStatus={this.handleToggleStatus}
                    checkStatusText={this.state.completedStatusText}
                    completedDisabled={this.state.completedDisabled}
                    imageUpdateModal={this.imageUpdateModal}
                    userId={this.props.recruiterDetails.user_id}
                    handleNoticePeriodChange={this.handleNoticePeriodChange}
                    handleJobTypeChange={this.handleJobTypeChange}
                    handleCandidateNameEdit={this.handleCandidateNameEdit}
                    handleCandidateNameChange={this.handleCandidateNameChange}
                    handleCandidateNameOnBlur={this.handleCandidateNameOnBlur}
                    handleCandidateEmailEdit={this.handleCandidateEmailEdit}
                    handleCandidateEmailChange={this.handleCandidateEmailChange}
                    handleCandidateEmailOnBlur={this.handleCandidateEmailOnBlur}
                    focusInput={(event)=>this.focusInput(event)}
                    errorPosition={this.state.errorPosition}
                  />
                </div>
                <Form className="">
                  <Accordion isAccordion={true} defaultActiveKey={1} activeCandidateId={this.props.activeCandidateId}>
                    <AccordionItem accordionKey={1} title="Recruiter's Comments">
                      <div className="profile-edit__section profile-edit__section--comments">
                        <RecruiterComments candidate={candidate}
                          recruiter_comments={candidate.recruiter_comments}
                          handleRecruiterCommentChange={this.handleRecruiterCommentChange}
                          handleUpdateProfile={this.handleUpdateProfile}
                          commentsActive={this.state.commentsActive}
                          errorMsg={this.state.errorMsg}
                          errorPosition={this.state.errorPosition}
                          handleOnBlur={this.handleOnBlur}/>
                      </div>
                    </AccordionItem>

                    <AccordionItem accordionKey={2} title='Experience'>
                      <div className="profile-edit__section profile-edit__section--experience">
                        <Experience 
                          candidate={candidate} 
                          handleExperienceChange={this.handleExperienceChange}
                          handleUpdateProfile={this.handleUpdateProfile}
                          handleExperienceDateChange={this.handleExperienceDateChange}
                          handleCurrentRole={this.handleCurrentRole}
                          addExperience = {this.addExperience}
                          removeExperience = {this.removeExperience}
                          experActive={this.state.experActive}
                          blurId = {this.state.blurId}
                          fieldPosition = {this.state.fieldPosition}
                          errorMsg={this.state.errorMsg}
                          errorPosition={this.state.errorPosition}                  
                          expErrorFieldIndex={this.state.expErrorFieldIndex}
                          handleOnBlurExperience={this.handleOnBlurExperience}
                        />
                      </div>
                    </AccordionItem>

                    <AccordionItem accordionKey={3} title='Skills' errorMsg={(this.state.errorPosition === 'skills') ? this.state.errorMsg : null }>
                      <div className="profile-edit__section profile-edit__section--skills skillsedittag">
                        <Skills 
                          candidate={candidate}
                          addSkill={this.addSkill}
                          handleSkillChange={this.handleSkillChange}
                          handleUpdateProfile={this.handleUpdateProfile}
                          skillsActive={this.state.skillsActive}
                          errorMsg={this.state.errorMsg}
                          errorPosition={this.state.errorPosition}
                          handleSkillOnBlur={this.handleSkillOnBlur}
                          handleSkillRemove={this.handleSkillRemove}
                          skillName={this.state.skillName}
                          handleSkillOnEnter={this.handleSkillOnEnter}
                          /> 
                      </div>
                    </AccordionItem>

                    <AccordionItem accordionKey={4} title='Education and Training'>
                      <div className="profile-edit__section profile-edit__section--education">
                        <Education 
                          candidate={candidate}
                          handleEducationChange={this.handleEducationChange}
                          handleEducationDateChange={this.handleEducationDateChange}
                          handleIsTraining={this.handleIsTraining}
                          handleUpdateProfile={this.handleUpdateProfile}
                          addEducation ={this.addEducation}
                          removeEducation = {this.removeEducation}
                          edtnActive={this.state.edtnActive}
                          errorMsg={this.state.errorMsg}
                          errorPosition={this.state.errorPosition}
                          blurId = {this.state.blurId}
                          fieldPosition = {this.state.fieldPosition}
                          edtnErrorFieldIndex={this.state.edtnErrorFieldIndex}
                          handleOnBlurEducation={this.handleOnBlurEducation}/>
                      </div>
                    </AccordionItem>

                    <AccordionItem accordionKey={5} title='Languages' errorMsg={(this.state.errorPosition === 'language') ? this.state.errorMsg : null }>
                      <div className="profile-edit__section profile-edit__section--languages">
                        <Languages 
                          candidate={candidate}
                          addLanguage={this.addLanguage}
                          handleLanguageChange={this.handleLanguageChange}
                          handleUpdateProfile={this.handleUpdateProfile}
                          langActive={this.state.langActive}
                          errorMsg={this.state.errorMsg}
                          errorPosition={this.state.errorPosition}
                          handleLanguagesOnBlur={this.handleLanguagesOnBlur}/>
                      </div>
                    </AccordionItem>

                    <AccordionItem accordionKey={6} title='Interests' errorMsg={(this.state.errorPosition === 'hobby') ? this.state.errorMsg : null }>
                      <div className="profile-edit__section profile-edit__section--hobbies">
                        <Hobbies
                          candidate={candidate}
                          addHobby={this.addHobby}
                          handleHobbyChange={this.handleHobbyChange}
                          handleUpdateProfile={this.handleUpdateProfile}
                          hobbiesActive={this.state.hobbiesActive}
                          errorMsg={this.state.errorMsg}
                          errorPosition={this.state.errorPosition}
                          handleHobbiesOnBlur={this.handleHobbiesOnBlur}/>
                      </div>
                    </AccordionItem>
                  </Accordion>
                </Form>        

              </Tab>
            </Tabs> 
            {/* { this.state.alertVisible ?
            <div className={"auto-save " + this.state.alertStyle} onDismiss={this.handleAlertDismiss}>
              {this.getAlertMsg()}
            </div> : ''
          }  */}
          {this.state.isShowToast?
          <ToastNotification 
            isShowToast={this.state.isShowToast} 
            message={this.state.toastMessage} 
            variant={this.state.toastVariant} 
            autoClose={this.state.toastAutoClose}
            onClose={this.handleCloseToastNotification}
            toastId= {this.state.toastId} 
          />
          :""}
          <Modal show={this.state.showImageUploadModal===true} onHide="" className="candidate-imageUpload-modal">
            <div className="close-icon-div">
              <Icon icon="close-icon"  className="close-icon" onClick={this.closeShowImageUploadModal} />
            </div>
            <h2 className="candidate-image-modal-header">Upload Photo</h2>
            <div className="candidate-image-upload">
              <div className="candidate-profile-picture">
               {this.state.file? <FilePreview data={this.state.file} candidateImageUpload={true}/>:
                <CandidatePhoto 
                initials={this.props.candidateProfile.initials} 
                candidatePhoto={(this.state.uploadStatus === "remove" || this.state.savingData) ? null : this.props.candidateProfile.s3SignedUrl} 
                user={this.props.user} 
                attributes={this.props.attributes} 
                isS3Url={this.props.isS3Url} 
                />
              }
              </div>
              {(this.props.candidateProfile.s3SignedUrl || this.state.file )? 
                <div className="candidate-photo-remove" ><p className="candidate-photo-remove-click" onClick = {()=>this.removeCandidateImage(this.props.candidateProfile.id,this.props.candidateProfile.candidate_image)}>Remove</p></div> : ""
              }
                <FileUpload multiple={false} 
                  name='profile-image-upload'
                  maxSize={1000*1000}
                  acceptedTypes="image/*"
                  handleFileSelect={this.addFile}
                  candidateImageUpload={true} 
                  previews={this.previews}
                  ref={this.child}
                />
                
            </div>
            <div className="candidate-upload-photo-div">
              <div className="imageAlert">
                {(this.state.fileUploadError) ? <span className="error-message">{this.state.fileUploadError} </span>:""}
                
                <Button className="client-upload-photo-button" onClick={() => this.onDrop(this.state.file)} disabled={(this.state.uploadStatus==null || (this.state.uploadStatus=="remove" && !this.props.candidateProfile.s3SignedUrl)) ?true:false}>
                  Save
                </Button>
              </div>                              
            </div> 
          </Modal>
          </div>
          :
          <div className="rec-profile-edit-loader">
            <div className="profile-tabs">
              <ul role="tablist" class="nav nav-tabs">
                <li role="presentation" class="active">
                  <a href="#"></a>
                </li>
              </ul>
            </div>
            <div className="timeline-wrapper">
              <div class="candidate-overview">
                <div class="profile-picture-container">
                  <div class="profile-picture">
                    <div class="Candidate-Photo-Container">
                      <div className="background-mask face-mask"></div>
                    </div>
                  </div>
                </div>
                <div class="details">
                  <h1 class="candidate-name"><div className="background-mask line-mask"></div></h1>
                  <div class="highlight-experience row">
                    <div class="col-md-6 col-xs-12"><div className="background-mask line-mask"></div></div>
                    <div class="col-md-6 col-xs-12"><div className="background-mask line-mask"></div></div>
                  </div>
                  <div class="email-wrapper">
                  </div>
                  <div>
                    <div class="line"></div>
                    <div class="prev-experience-container">
                      <h2 class="cs"><div className="background-mask line-mask"></div></h2>
                      <div class="show-grid previous-experience-content row">
                        <div class="col-md-12">
                          <div className="background-mask line-mask"></div>
                        </div>
                      </div>
                    </div>
                    <div class="lineb notice-period-line"></div>
                    <div class="row">
                      <div class="col-md-6 col-xs-12"><span class="notice"><div className="background-mask line-mask"></div></span></div>
                      <div class="col-md-6 col-xs-12"><span class="jobtype"><div className="background-mask line-mask"></div></span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        }
        </div>
      </div>
    );
  }
}

/**
* @desc connecting to redux store
* @param state
* @return redux state
*/
const mapStateToProps = state => {
  return {
    candidateProfile: state.candidateProfile.profileInfo,
    activeCandidateId: state.talentPool.activeCandidateId, 
    recruiterDetails: state.clientProfile.clientDetails,
    user: state.cognito.user,
    attributes: state.cognito.attributes,    
    userDetail: state.clientProfile.clientDetails
  };
}

/**
* @desc connecting to redux actions
* @param dispatch
* @return redux actions
*/
const mapDispatchToProps = dispatch => {
  return {
    onCandidateProfileDataChange :(profileInfo)=>dispatch(actions.setCandidateProfile(profileInfo)),
    onCurrentRoleChange: (candidateId, currentJobTitle, currentEmployer) => dispatch(actions.setCurrentRole(candidateId, currentJobTitle, currentEmployer)),
    onUpdateCandidateEditStatus: (candidateId, edit_status) => dispatch(actions.setEditStatus(candidateId, edit_status)),
    onUpdateCandidateProfileImage:(candidateImage,candidateId,user)=>dispatch(actions.updateCandidateProfileImage(candidateImage,candidateId,user)),
    onCandidateProfileChange: (candidateId, candidateName,candidateInitials, candidateEmail,candidateNoticeperiod,candidateJobtype) => dispatch(actions.setCandidateProfileEdit(candidateId, candidateName,candidateInitials, candidateEmail,candidateNoticeperiod,candidateJobtype)),
  }  
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(ProfileEdit,axios));



// WEBPACK FOOTER //
// ./src/container/Recruiter/ProfileEdit/ProfileEdit.js